var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticClass:"mt-24",staticStyle:{"background-color":"#ffffff"},attrs:{"src":`${_vm.chartbrewUrl}?theme=light`,"allowTransparency":"true","height":"800px","width":"100%","frameborder":"0"}})
}
var staticRenderFns = []

export { render, staticRenderFns }